import { ClassData } from "../dtos/classes.type";

interface ClassMetadata {
  pricing_override?: string | number | null;
}

export function getEffectiveClassPrice(
  classData: ClassData,
  classMetadata?: ClassMetadata | null
): number {
  const overrideValue = classMetadata?.pricing_override;

  if (overrideValue !== null && overrideValue !== undefined && `${overrideValue}`.trim() !== "") {
    const parsedOverride = Number(overrideValue);
    if (Number.isFinite(parsedOverride) && parsedOverride >= 0) {
      return parsedOverride;
    }
  }

  return classData.tuition.fee;
}
